import { gql } from "@outschool/ui-apollo";
import { PublicReviewFragment } from "@outschool/ui-components-website";

export const listAllCuratedCategoryPagesQuery = gql`
  query listAllCuratedCategoryPages {
    curatedPages {
      slug
    }
  }
`;

export const CuratedCategoryPageQuery = gql`
  query ContentfulCategoryPage(
    $categorySlug: String!
    $locale: String
    $preview: Boolean
  ) {
    contentfulCategoryPageCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
      where: { categorySlug: $categorySlug }
    ) {
      items {
        featuredClassesOverrideSlug
        heroTitle
        heroDescription {
          json
        }
        heroImage {
          url(transform: { quality: 85, width: 503, height: 335, format: WEBP })
        }
        heroValueProps {
          json
        }
        jumpPillsTitle
        jumpPillLinksCollection {
          items {
            path
            text
          }
        }
        belowTheFoldTitle
        belowTheFoldDescription {
          json
        }
        startAfter
        footerCtaTitle
        footerCtaPath
        magnetPagesCollection {
          items {
            magnetPageSlug
            categoryLabel {
              value
            }
            title
            author {
              name
              profileImage {
                url
              }
            }
            headerImage {
              url(
                transform: {
                  quality: 85
                  width: 692
                  height: 302
                  format: WEBP
                }
              )
            }
          }
        }
      }
    }
  }
`;

export const CuratedCategoryPageRelatedCarouselsQuery = gql`
  query ContentfulCategoryPageRelatedCarousels(
    $categorySlug: String!
    $locale: String
    $preview: Boolean
  ) {
    contentfulCategoryPageCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
      where: { categorySlug: $categorySlug }
    ) {
      items {
        relatedCategoriesCollection {
          items {
            callToActionText
            callToActionUrl
            subtitle
            title
            upsellName

            adminTags
            ages
            capacityMax
            capacityMin
            category
            deliveryTypes
            formats
            fundingPrograms
            gradeLevel
            maxPriceCents
            minPriceCents
            multiTermQuery
            query
          }
        }
      }
    }
  }
`;

export const CuratedCategoryPageReviewsQuery = gql`
  query feedbackForCategorySearchFilters(
    $searchFilters: SearchFilters!
    $pageLocation: String
  ) {
    feedbackForCategorySearchFilters(
      searchFilters: $searchFilters
      pageLocation: $pageLocation
      limit: 10
      minFeedbackLength: 100
      maxFeedbackLength: 300
      minStarRating: 4
      minHelpfulCount: 0
    ) {
      hasPhotos {
        activity {
          title
          titleTranslated
          path
          isClub
          slug_id
        }
        parent {
          publicName
          photo
        }
        ...PublicReviewFragment
      }
      noPhotos {
        activity {
          title
          titleTranslated
          path
          isClub
          slug_id
        }
        parent {
          publicName
          photo
        }
        ...PublicReviewFragment
      }
    }
  }
  ${PublicReviewFragment}
`;
